module.exports = __webpack_public_path__ + "static/media/welcome-rockstar-bg.4cdd8c18.svg";